import { FC, ReactNode } from 'react';
import { Drawer as MUIDrawer, DrawerProps } from '@mui/material';

export type AppDrawerProps = DrawerProps & {
  children?: ReactNode;
};

export const Drawer: FC<AppDrawerProps> = ({ children, sx, ...props }) => {
  return (
    <MUIDrawer
      {...props}
      sx={[
        {
          '& .MuiDrawer-paper': {
            borderRadius: 0,
            boxShadow: 'none',
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </MUIDrawer>
  );
};
